export enum Locale {
    ENGLISH = 'en_US',
    DUTCH = 'nl_BE',
    FRENCH = 'fr_BE'
}
